<template>
  <v-avatar color="primary" size="80" class="main">
    <v-avatar color="white" size="72">
      <v-avatar color="#f8f8f9" size="56">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <p class="primary--text text-h6 pa-0 ma-0" v-text="minutes" />
              <p class="primary--text text-caption pa-0 ma-0" v-text="'min'" />
            </v-col>
          </v-row>
        </v-container>
      </v-avatar>
    </v-avatar>
  </v-avatar>
</template>

<script>
export default {
  name: "TimeLeft",
  props: {
    minutes: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    leftTime: 0,
    direction: "top",
    fab: false,
  }),
};
</script>
<style lang="scss" scoped>
.main {
  /* position: absolute !important; */
  z-index: 2 !important;
}
.right {
  right: 0;
}
.left {
  left: 0;
}

p {
  line-height: 0.9rem !important;
}
</style>
